import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {i18nizeDate, selectStyles} from '../../../../helpers/Utils';
import KycDetails from '../../../../containers/KycDetails';
import KycFeedbackForm from '../../../../containers/KycFeedbackForm';
import ModalManager from '../../../../components/modal/ModalManager';
import {NotificationManager} from '../../../../components/common/react-notifications';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import DocumentFilterForm from '../../../../containers/DocumentFilterForm';
import ToolTip from '../../../../components/ToolTip';
import {BigPlayButton, Player} from "video-react";
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, find, isArray} from 'lodash';
import Rbac from '../../../../components/Rbac';
import Zoom from 'react-medium-image-zoom';
import Select from 'react-select';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pages: -1,
      expanded: {},
      loading: false,
      refreshing: false,
    };
    this.statusOptions = [
      {value: 'Submitted', label: props.t('Submitted')},
      {value: 'Pending', label: props.t('Pending')},
      {value: 'Verified', label: props.t('Verified')},
      {value: 'Rejected', label: props.t('Rejected')},
    ];
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderDocumentFilter = this.renderDocumentFilter.bind(this);
    this.renderStatusCell = this.renderStatusCell.bind(this);
    this.renderValueCell = this.renderValueCell.bind(this);
  }

  fetchKycItems = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/user-kyc-items',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? mapValues(keyBy(state.filtered, 'id'), 'value') : null),
          }
        });
      this.setState({
        items: data.kycItems,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchKycItems(state);
    this.setState({loading: false});
  };

  updateKycItem = async (values, index) => {
    try {
      await Api.invoke('PATCH', '/admin-ui/user-kyc-items', values);
      this.updateList(values, index);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onChangeStatus = async (selected, id, feedback, index) => {
    const values = {status: selected.value, id};
    if (selected.value !== 'Rejected') {
      await this.updateKycItem(values, index);
    } else {
      this.showKycFeedbackForm(values, feedback, index);
    }
  };

  updateList = (values, index) => {
    const {t} = this.props;
    const {items} = this.state;
    let list = [...items];
    list.splice(index, 1, {...items[index], ...values});
    this.setState({items: list});
    NotificationManager.success(t('Kyc item updated successfully'), t('Message'));
  };

  showKycFeedbackForm = (values, feedback, index) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Submit Feedback'),
      body: <KycFeedbackForm
        values={values}
        feedback={feedback}
        onSubmit={async data => {
          await this.updateKycItem(data, index);
        }}/>,
    });
  };

  getColumns = t => [
    {
      Header: t('National Code'),
      accessor: 'nationalCode',
      width: 150,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('First Name'),
      accessor: 'legalFirstName',
      filterable: true,
      width: 100,
      Cell: props => <span>{props.value}</span>,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Last Name'),
      accessor: 'legalLastName',
      filterable: true,
      width: 150,
      Cell: props => <span>{props.value}</span>,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Email'),
      accessor: 'email',
      filterable: true,
      Cell: props => <span>{props.value}</span>,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Phone Number'),
      accessor: 'phoneNumber',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 170,
      Cell: props => <div className="d-flex flex-row align-items-center">
        <span className='mr-2'>{props.value}</span>
        <span className={props.original.phoneNumberVerified ? 'text-success' : 'text-danger'}>
          {` (${props.original.phoneNumberVerified ? t('confirmed') : t('not confirmed')})`}
        </span>
      </div>,
    },
    {
      Header: t('Document Name'),
      accessor: 'items',
      width: 200,
      filterable: true,
      Cell: props => <span>{t(props.original.name)}</span>,
      Filter: this.renderDocumentFilter,
    },
    {
      Header: t('Submitted Document'),
      accessor: 'value',
      width: 200,
      Cell: this.renderValueCell,
    },
    {
      Header: t('Document Status'),
      accessor: 'status',
      width: 150,
      filterable: true,
      Cell: this.renderStatusCell,
      Filter: this.renderStatusFilter,
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 120,
    },
    {
      Header: '',
      accessor: 'userId',
      width: 45,
      Cell: props => <Link to={{
        pathname: '/dashboard/users/' + props.value,
      }}
      > <i className="simple-icon-eye view-icon"/> </Link>,
    },
  ];

  renderValueCell(props) {
    const {id, type} = props.original;
    let values = [];
    if (!isArray(props.value)) {
      values = [props.value];
    }
    if (type === 'text') {
      return (
        <div className='d-flex flex-row align-items-center justify-content-around'>
          {values.map((value, index) => (
            <span key={`${id}-${index}`}>{props.value}</span>
          ))}
        </div>
      );
    }
    if (type === "image") {
      return (
        <div className='d-flex flex-row align-items-center justify-content-around'>
          {values.map((value, index) => (
            <div key={`${id}-${index}`}>
              <img
                onClick={() => {
                  const {legalFirstName, legalLastName, email, nationalCode} = props.original;
                  const username = legalFirstName ? `${legalFirstName} ${legalLastName}` : email;
                  const nationalId = nationalCode ? `(${this.props.t("National Code")}: ${nationalCode})` : '';
                  ModalManager.open({
                    size: 'lg',
                    isOpen: true,
                    body: <Zoom><img src={value} width="100%" height="100%"/></Zoom>,
                    title: `${username} ${nationalId}`,
                  });
                }}
                className="cursor-pointer"
                src={value}
                height={40}
                width={40}
              />
            </div>
          ))}
        </div>
      );
    }
    return  (
      <div className='d-flex flex-row align-items-center justify-content-around'>
        <div key={`${id}`}>
          <img
            onClick={() => {
              const {legalFirstName, legalLastName, email, nationalCode} = props.original;
              const username = legalFirstName ? `${legalFirstName} ${legalLastName}` : email;
              const nationalId = nationalCode ? `(${this.props.t("National Code")}: ${nationalCode})` : '';
              ModalManager.open({
                size: 'lg',
                isOpen: true,
                title: `${username} ${nationalId}`,
                body: <Player>
                  <BigPlayButton position="center" />
                  <source src={values[0]} />
                </Player>
              });
            }}
            className="cursor-pointer"
            src="/assets/img/player.svg"
            height={40}
            width={40}
          />
        </div>
      </div>
    );
  }

  renderStatusCell(props) {
    const {t} = this.props;
    const {id, feedback} = props.original;
    return (
      <Select
        className="w-100"
        styles={{
          ...selectStyles,
          menu: provided => ({
            ...provided,
            position: 'relative',
          }),
        }}
        options={this.statusOptions}
        onChange={async selected => {await this.onChangeStatus(selected, id, feedback, props.index);}}
        value={find(this.statusOptions, {'value': props.value})}
        isDisabled={!Rbac.hasPermission('update_user-kyc')}
        placeholder={t('Select')}
      />
    );
  }

  renderDocumentFilter({filter, onChange}) {
    const {t} = this.props;
    const value = filter ? filter.value.split(',').map(item => t(item)).join(',') : '';
    return (
      <ToolTip id="items-filter" text={value || t('all')}>
        <input
          value={value}
          style={{width: '100%'}}
          onClick={() => {
            this.openDocumentFilterModal(filter, onChange);
          }}
        />
      </ToolTip>
    );
  }

  openDocumentFilterModal = (filter, onChange) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Document Filter'),
      body: <DocumentFilterForm filter={filter} onChange={onChange} />,
    });
  };

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      ...this.statusOptions,
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchData(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Kyc items list updated successfully'), t('Message'));
  };

  render() {
    const {t, match} = this.props;
    const {items, pages, expanded, loading, refreshing} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    disabled={refreshing || loading}
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.refreshList}>
                    <i className='icon-File-Refresh text-large'/>
                    <span className="mx-1">{t('Refresh')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={items}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  expanded={expanded}
                  defaultPageSize={25}
                  style={{width: '100%'}}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <KycDetails
                        kycInfo={original}
                        itemIndex={row.index}
                        showKycFeedbackForm={this.showKycFeedbackForm}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
